/**
 * MultiLensPicker — operator chooses which persona's trail to reply to
 * when the lens is in multi mode. The selection is sticky (writes to
 * lens.lastMultiTarget) so subsequent sends default to the same persona.
 */
import React from 'react';
import type { PickerOption } from '../../../contexts/lensWriteTarget';


interface MultiLensPickerProps {
  pickerOptions: PickerOption[];
  selectedPersonaId: string;
  onSelect: (personaId: string) => void;
}


export const MultiLensPicker: React.FC<MultiLensPickerProps> = ({
  pickerOptions, selectedPersonaId, onSelect,
}) => {
  if (pickerOptions.length === 0) return null;
  return (
    <div
      data-multi-lens-picker
      className="flex flex-wrap gap-1 items-center text-xs mb-1 shrink-0"
    >
      <span className="text-slate-500 dark:text-slate-400">Reply to:</span>
      {pickerOptions.map((p) => {
        const active = p.personaId === selectedPersonaId;
        return (
          <button
            key={p.personaId}
            onClick={() => onSelect(p.personaId)}
            className={`px-2 py-0.5 rounded transition-colors ${
              active
                ? 'bg-indigo-500 text-white'
                : 'bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-300 dark:hover:bg-slate-600'
            }`}
            aria-pressed={active}
          >
            {p.personaName || p.personaId}
          </button>
        );
      })}
    </div>
  );
};
